<template>
  <teleport to="body">
    <div v-if="active" class="modal-container" @mousedown.self="containerClicked">
      <div class="modal" ref="modalElement" :class="['modal-' + size]">
        <div v-if="$slots.header" class="modal-header">
          <slot name="header">&nbsp;</slot>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div v-if="$slots.footer" class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import {modal} from "../../../index";
import {onMounted, onUnmounted, ref, watch} from "vue";
import {useRoute} from "vue-router";

const props = defineProps({
  active: Boolean,
  size: {
    type: String,
    default: "medium",
    validator(value) {
      return ["small", "medium", "large", "xlarge"].includes(value);
    }
  }
});

const lastState = ref(false);
const firstRoutePath = ref(undefined);

const modalElement = ref(undefined);

const emit = defineEmits(["update:active"]);

const route = useRoute();

function containerClicked(event) {
  if (event.target.contains(modalElement.value)) {
    emit('update:active', false);
  }
}

onMounted(() => {
  firstRoutePath.value = route.path;
});

onUnmounted(() => {
  if (props.active && modal.count > 0) modal.count -= 1;
});

watch(() => props.active, value => {
  if (value === undefined) return;
  if (value === lastState.value) return;
  lastState.value = value;
  if (value) {
    modal.count += 1;
  } else {
    if (modal.count > 0) {
      modal.count -= 1;
    }
  }
}, {
  immediate: true
});

watch(route, () => {
  if (props.active && firstRoutePath.value !== route.path) {
    modal.count = 0;
  }
  firstRoutePath.value = route.path;
});

watch(() => modal.count, value => {
  if (value === 0 && props.active) {
    emit("update:active", false);
  }
});

</script>